import MainApe from '../../assets/images/mainApe.png'
import GreenLines from '../../assets/images/greenLines.png'
import Ball from '../../assets/images/ball.png'
import RightBall from '../../assets/images/elipse2.png'
import vector1 from '../../assets/images/vector1.png'
import vector2 from '../../assets/images/vector2.png'
import vector3 from '../../assets/images/vector3.png'
import {
    ButtonRegister,
    Subtitle,
    InputRegister,
    ProjectDescription,
    RevealText,
    HeaderTitle,
    MainSectionWrapper,
    ProjectDescriptionText,
    SectionWrapperDescription
} from './styles'


const MainSection = () => {
    return (
        <MainSectionWrapper>
            <div style={{
                backgroundImage: `url(${GreenLines}), url(${Ball})`,
                backgroundRepeat: 'no-repeat no-repeat',
                backgroundPosition: '50px,left',

            }}>
                <img src={MainApe} />
            </div>
            <SectionWrapperDescription style={{
                backgroundImage: `url(${RightBall})`,
            }}>
                <HeaderTitle style={{
                    backgroundImage: `url(${vector1}), url(${vector2}), url(${vector3})`,
                    backgroundRepeat: 'no-repeat, no-repeat, no-repeat',
                    backgroundPosition: '600px 1px, 600px 34px, 600px 69px ',
                }}>EXCLUSIVE</HeaderTitle>
                <Subtitle >newest NFT release</Subtitle>
                <ProjectDescription>
                    <ProjectDescriptionText>
                        The <b>BILLIONAIRE CLUB</b> is a private collection of 10 000 billionaire <small style={{ marginLeft: 10, color: "#121212" }}>space</small> apes NFTs—unique digital collectibles. The apes are stored as ERC-721 tokens on the Ethereum blockchain and hosted on IPFS.
                    </ProjectDescriptionText>
                    <RevealText> Reveal on October 20th.</RevealText>
                    <div style={{ display: 'flex' }}>
                        <InputRegister placeholder='your@email.com ' />
                        <ButtonRegister>Register</ButtonRegister>
                    </div>
                </ProjectDescription>
            </SectionWrapperDescription>
        </MainSectionWrapper>
    )
}

export default MainSection